import { Component, Input } from '@angular/core';
import { ErrorFieldGroup, ErrorDefinition, ErrorField } from './form.objects';
import { FormService } from './form.service';
import { HelpService } from '../common/help/help.service';
import { FieldGroup, I18nDescribable, IEvaluableExecutor } from '../../api/contract-notice-dto';

@Component({
  selector: 'plyca-validation-group',
  templateUrl: 'validationGroup.template.html'
})
export class ValidationGroupComponent {

  @Input()
  errorGroup: ErrorFieldGroup;
  @Input()
  unmapedErrors: ErrorDefinition[];

  public showErrors = false;

  constructor(public formService: FormService, protected helpService: HelpService) { }

  showHelpEntries(errorField: ErrorField) {
    if (errorField && errorField._field && errorField._field.helpEntries) {
      let searchText = errorField._field.helpEntries ? errorField._field.helpEntries.join(' ') : undefined;
      this.helpService.openSearchDialog(searchText);
    } else {
      console.log('NO HELPENTRIES AVAILABLES FOR ');
    }
  }

  helpEntriesAvailable(errorField: ErrorField) {
    return (errorField && errorField._field && errorField._field.helpEntries && errorField._field.helpEntries.length > 0);
  }

  public getGroupDescription(errorGroup: ErrorFieldGroup): string {
    return this.formService.getEvalDescription(errorGroup, errorGroup, this.errorGroup);
  }

  public getFieldDescription(fieldGroup: ErrorField): string {
    return this.formService.getEvalDescription(fieldGroup, fieldGroup, this.errorGroup);
  }


}

